<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dJoQ2p/tc-custom/9781612436555.jpg?1720281561047" alt="This image is the cover for the book Gastroparesis Healing Diet"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gastroparesis Healing Diet
      </h1>
      <p class="bookDescription body article font2">
        <b>From a certified nutrition consultant, a customizable approach to overcoming symptoms of gastroparesis through a personalized nutritional program.</b><br/><br/>With no identifiable cause, no known cure and life-sapping symptoms, gastroparesis can make you feel helpless. But you’re not! <i>The Gastroparesis Healing Diet</i> empowers you to tame your symptoms by taking total control of your diet.<br/><br/>Featuring a step-by-step program that you personalize for your specific needs, this helpful handbook offers:<br/><br/>• A guided elimination diet for identifying triggers<br/><br/>• Carefully formulated yet amazingly delicious recipes<br/><br/>• A plan to stock your pantry with nutrient-dense foods<br/><br/>• Tips and tricks for dealing with flare-ups<br/><br/>• Shared stories from others with gastroparesis<br/><br/>• Advice on reducing stress and finding support
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tammy Chang
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Ulysses Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fa68c5f0